export const ROLES = {
  ADMIN:    1,
  LAB:      2,
  PHARMACY: 3,
  SUPPORT:  4,
};
